










































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import GExamCreateFormFormat from '../GExamCreateFormFormat.vue';
import { email, required } from 'vuelidate/lib/validators';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import GVTag from '@/components/GVTag.vue';
import moment from 'moment';
import { globalModule } from '@/store/modules/global.module';
import { examCreateModule } from '@/store/modules/frames/exam-create.module';

@Component({
  name: 'GExamCreateBaseSettingDateSpan',
  components: { GVTag, GExamCreateFormFormat },
  computed: {},
  methods: {},
  validations: {
    startTime: { required },
    deadline: { required },
  },
})
export default class GExamCreateSpan extends mixins(GPageBase) {
  isStartTimeChange: boolean = false;
  mounted() {
    if (this.evalSettingDetail.startTime === null) {
      this.evalSettingDetail.startTime = globalModule.isNewSchoolYear ? new Date(globalModule.selectedSchoolYear, 3, 1) : null;
    }
  }

  get startTime(): Date {
    return this.evalSettingDetail.startTime;
  }

  get deadline(): Date {
    return this.evalSettingDetail.deadline;
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get evalSettingModeEditAndUnderExamination(): boolean {
    return examCreateModule.evalSettingModeEdit && this.evalSettingDetail.isUnderExamination;
  }

  get isStartTimeInvalid(): boolean {
    return this.$v.startTime.$dirty && this.$v.startTime.$invalid;
  }
  get isStartTimeBeforeCurrentTime(): boolean {
    return moment(this.evalSettingDetail.startTime) <= moment(new Date()).add(-5, 'm');
  }

  get isDeadlineInvalid(): boolean {
    return this.$v.deadline.$dirty && this.$v.deadline.$invalid;
  }

  get isDeadlineBeforeStartTime(): boolean {
    return !this.$v.startTime.$invalid && !this.$v.deadline.$invalid && moment(this.evalSettingDetail.deadline) <= moment(this.evalSettingDetail.startTime);
  }

  touchDeadline(): void {
    this.$v.deadline.$touch();
  }

  // iviewのDatePickerのoptionsに入れるオブジェクト
  get dateOption() {
    const startDate: Date = globalModule.isNewSchoolYear ? new Date(globalModule.selectedSchoolYear, 3, 1) : new Date();
    const endDate : Date = new Date(globalModule.selectedSchoolYear + 1, 3, 1);
    const startDateMoment = moment(startDate);
    const endDateMoment = moment(endDate);
    return {
      disabledDate(date: Date) {
        // 開始日（startDate）より以前、終了日（endDate）より以降であれば true を返す => disabled
        // 「開始日以前」または「終了日以降」であれば選択不可
        return (date && moment(date).isBefore(startDateMoment, 'day') || moment(date).isSameOrAfter(endDateMoment, 'day'));
      },
    };
  }

  /**
   * 開始時間変更時
   */
  handleStartTimeChange(value: string) {
    this.isStartTimeChange = true;
    this.evalSettingDetail.startTime = value === '' ? null : moment(value).toDate();
    this.$v.startTime.$touch();
  }

  /**
   * 終了時間変更時
   */
  handleDeadlineChange(value: string) {
    this.evalSettingDetail.deadline = value === '' ? null : moment(value).toDate();
    this.touchDeadline();
  }

  touch() {
    this.$v.$touch();
  }

  isValid(): boolean {
    if (this.evalSettingModeEditAndUnderExamination) {
      // 受検開始後の編集の場合、開始日時が現在時刻より前かどうかの判定はしない
      return !this.isStartTimeInvalid && !this.isDeadlineInvalid && !this.isDeadlineBeforeStartTime;
    } else {
      return !this.isStartTimeInvalid && !this.isStartTimeBeforeCurrentTime && !this.isDeadlineInvalid && !this.isDeadlineBeforeStartTime;
    }
  }
}
